import * as React from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import { HIRING_PERMISSION, EMPLOYEE_PERMISSION } from '../util/permissions';

type InputProps = {
  employeesPermission: string;
  hiringPermission: string;
  onHiringPermissionChange: Function;
  onEmployeePermissionChange: Function;
};

export class UserPermissionForm extends React.PureComponent<InputProps> {
  handleHiringPermissionChange = (e: any) => {
    const { checked } = e.currentTarget;
    let { value } = e.currentTarget;
    value = checked ? HIRING_PERMISSION.ALL : HIRING_PERMISSION.NONE;
    this.props.onHiringPermissionChange(value);
  };

  handleEmployeesPermissionChange = (e: any) => {
    const { checked } = e.currentTarget;
    let { value } = e.currentTarget;
    // DL (04/06/2020): The form submits with an empty string value for a checkbox. If the
    // user is checking the employee box, we want to default to all access,
    // and if they are unchecking it, we want no access.
    if (!value && !checked) {
      value = EMPLOYEE_PERMISSION.NONE;
    }
    if (!value && checked) {
      value = EMPLOYEE_PERMISSION.ALL;
    }
    this.props.onEmployeePermissionChange(value);
  };

  render() {
    const { employeesPermission, hiringPermission } = this.props;
    const hasPermissionToNothing =
      employeesPermission === EMPLOYEE_PERMISSION.NONE &&
      hiringPermission === HIRING_PERMISSION.NONE;
    const hasEmployeePermission =
      employeesPermission === EMPLOYEE_PERMISSION.ALL ||
      employeesPermission === EMPLOYEE_PERMISSION.SUPERVISOR;

    return (
      <>
        <div className="typo-label u-margin-top-xl">Access</div>
        {hasPermissionToNothing && (
          <div className="u-typo-body u-color-red">
            This user must have permission to something.
          </div>
        )}
        <div className="u-margin-bottom u-margin-top-sm">
          <div className="u-flex-center ">
            <Checkbox
              className="u-no-padding-left u-no-padding-bottom u-no-padding-top"
              checked={hiringPermission === HIRING_PERMISSION.ALL}
              onChange={this.handleHiringPermissionChange}
            />
            <div className="typo-title">
              <span className="typo-bold">Hiring:</span> jobs and applicants
            </div>
          </div>
        </div>
        <div className="u-flex-center ">
          <Checkbox
            className="u-no-padding-left u-no-padding-bottom u-no-padding-top"
            checked={hasEmployeePermission}
            onChange={this.handleEmployeesPermissionChange}
          />
          <div className="typo-title">
            <span className="typo-bold">Employees:</span> directory and communication
          </div>
        </div>
        {hasEmployeePermission && (
          <div className="u-padding-left-2x">
            <RadioGroup
              name="employeesPermission"
              value={employeesPermission}
              onChange={this.handleEmployeesPermissionChange}
              row
            >
              <FormControlLabel
                value={EMPLOYEE_PERMISSION.ALL}
                control={<Radio />}
                label="All Employees"
              />
              <FormControlLabel
                value={EMPLOYEE_PERMISSION.SUPERVISOR}
                control={<Radio />}
                label="Only Direct Reports"
              />
            </RadioGroup>
          </div>
        )}
      </>
    );
  }
}
